import type { Serializer } from '@sembo-private/utils';

import type { ModalQueryParamValue } from '@apps/main/new-desktop/core/models/navigation';

export const ModalSerializer: Serializer<ModalQueryParamValue> = {
  serialize: (modalQueryParam: ModalQueryParamValue): ModalQueryParamValue =>
    modalQueryParam,
  deserialize: (modalQueryParam: ModalQueryParamValue): ModalQueryParamValue =>
    modalQueryParam,
};
